import { normalizeCollectionResponse, normalizeRecordResponse, projectDetailParams, projectParams } from 'api';
import { client, computeHeaders } from 'queries';

export const projectQuery = async ({ req, params }) => {
	const formattedParams = { ...projectDetailParams, context: ['cache', 'ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/workspace/projects/${params.projectId}`,
		headers,
		params: formattedParams,
	});
	return normalizeRecordResponse(response);
};

export const projectsQuery = async ({ req, params, query }) => {
	const formattedParams = { ...projectParams, context: ['ssr'], ...query };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/workspace/projects`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};
